import { useMemo } from 'react';
import { useMediaQueries } from 'seagull';
import { handleRequest, sendErrReport } from "../../infra/utils";
import { useStoreActions } from "../../store/store-context";
import styles from "./GoogleButton.module.scss";
import { useUtmsParams } from "../../hooks/useUtmsParams";
import { errorMessages } from "../../pages/unAuthorizedPages/constants";
import { useLocationCommonActions } from "../../providers/LocationProvider";
import { routes } from "../../constants";
import { useEventReporter } from "../../event-reporter";
import { useIoContext } from "../../contexts";
import { ServerError } from "../../infra/ErrorResponse";
import { jsx as _jsx } from "react/jsx-runtime";
export default function GoogleButton(props) {
  const {
    ensureEmail,
    testid,
    onAuthSuccess,
    onAuthError
  } = props;
  const {
    reportToGtm,
    reportToAppcues,
    reportToHubspot,
    reportToHeap
  } = useEventReporter();
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    mobile
  } = useMediaQueries();
  const getUtms = useUtmsParams();
  const {
    getPageUrl
  } = useLocationCommonActions();
  const {
    locationReload,
    GoogleButton
  } = useIoContext();
  const buttonConfiguration = useMemo(() => {
    return {
      type: 'standard',
      locale: 'en_US',
      width: mobile ? 280 : 400,
      text: 'continue_with',
      theme: 'outline',
      logo_alignment: 'center',
      size: 'large'
    };
  }, [mobile]);
  async function onGoogleAuth(_ref) {
    let {
      credential
    } = _ref;
    const authToken = await handleRequest(api.auth.googleSignIn({
      pageUrl: getPageUrl(),
      idToken: credential,
      utms: getUtms(),
      ensureEmail
    }));
    if (!authToken.success) {
      if (authToken.error.body === 'invalid auth request: email does not match') {
        const currentPathWithLoginError = "".concat(location.pathname).concat(routes.loginError);
        location.assign(currentPathWithLoginError);
      }
      if (authToken.error.hasServerError(ServerError.EmailIsInvalid)) {
        onAuthError && onAuthError(errorMessages.noBusinessEmailError);
      } else {
        sendErrReport(authToken.error.body ? "GoogleButton - ".concat(authToken.error.body) : authToken.error);
        onAuthError && onAuthError();
      }
    } else if (authToken.data != null) {
      reportToGtm('form-success', 'google-sign-in');
      reportToAppcues('form-success', 'google-sign-in');
      reportToHubspot('google_sign_in');
      reportToHeap('googleSignIn', 'form-success', 'google-sign-in');
      logBI(11801);
      onAuthSuccess && onAuthSuccess();
      locationReload();
    } else {
      sendErrReport('GoogleButton - did not retrieve an auth token');
      onAuthError && onAuthError();
    }
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": testid || 'google-login',
    className: styles.buttonContainer,
    children: /*#__PURE__*/_jsx(GoogleButton, {
      googleClientId: window.googleAuthClientId,
      callback: onGoogleAuth,
      buttonConfiguration: buttonConfiguration
    })
  });
}